<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <v-card width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Cambia tu contraseña
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-divider ></v-divider>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <v-form @submit.prevent="changePassword()">
                      <v-text-field
                        v-model="current_password"
                        v-validate="'required'"
                        data-vv-name="current_password"
                        data-vv-as="contraseña actual"
                        :error-messages="errors.collect('current_password')"
                        label="Contraseña temporal"
                        color="black"
                        type="password"
                        hint="Ingresa tu contraseña temporal">
                      </v-text-field>
                      <v-text-field
                        v-model="password"
                        v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                        data-vv-name="password"
                        data-vv-as="contraseña"
                        :error-messages="errors.collect('password')"
                        label="Contraseña nueva"
                        color="black"
                        type="password"
                        hint="Ingresa una nueva contraseña">
                      </v-text-field>
                      <v-btn class="k-orange-linear white--text" type="submit" :disabled="loading" block large>ENTRAR</v-btn>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" :src="require('@/assets/img/colektia.png')"  width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LogRocket from 'logrocket';
import Sidebar from '@/components/login/Sidebar';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
  },
  data() {
    return {
      loading: false,
      current_password: '',
      password: '',
    };
  },
  computed: {
    isValid() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=(.*[a-zA-Z]){6,})(?=(.*\d){2,})(?=(.*[!@#$%^&*()]){2,}).{10,}$/;
      return regex.test(this.password);
    },
  },
  methods: {
    changePassword() {
      if (!this.isValid) {
        this.errors.add({
          field: 'password',
          msg: 'Contraseña invalida, verifique que la contraseña cumple con la politicas.',
        });
        return;
      }
      this.loading = true;

      this.axios.patch(`users/${this.$auth.user().id}`, {
        current_password: this.current_password,
        password: this.password,
        status: 'activo',
      }).then(({ data }) => {
        this.loading = false;
        if(data.code !== 200) {
          Object.keys(response.data.errors).forEach((item) => {
            this.errors.add({
              field: item,
              msg: response.data.errors[item][0],
            });
          });
        } else {
          this.$auth.refresh().then(async () => {
          const user = this.$auth.user();
          user.status = 'activo';
          if (process.env.NODE_ENV === 'production') {
            LogRocket.identify(user.id, {
              name: `${user.first_name} ${user.last_name}`,
              email: user.email,
            });
          }
          sessionStorage.setItem('password', true);
          this.$router.push({ name: 'home' });
        });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/FirstLogin.vue